/**
 * Synthetic object key inserted by `filterContextForUse` between general context fields
 * and the budget block. Clients should render this as spacing, not a labeled row.
 */
export const CONTEXT_DISPLAY_SECTION_BREAK = '__context_section_break__';
export function isContextDisplaySectionBreak(key) {
    return key === CONTEXT_DISPLAY_SECTION_BREAK;
}
/**
 * Maps internal API / snapshot field names to human-readable labels.
 * Used when context arrives with raw keys (e.g. history before API mapping),
 * and is a no-op when keys are already display names.
 */
const CONTEXT_FIELD_DISPLAY_NAMES = {
    date_created_formated: 'Created on',
    status: 'Status',
    scope: 'Scope',
    object_name: 'Name',
    owner: 'Owner',
    supervisor: 'Supervisor',
    date_deadline_txt: 'Deadline',
    period: 'Period',
    budgetValue: 'Budget value',
    cost: 'Cost',
    monthly_forecast: 'Monthly forecast',
    yearly_forecast: 'Yearly forecast',
    budget_forecast_overrun: 'Budget overrun (forecast)',
    budget_forecast_overrun_percent: 'Budget overrun (forecast, %)',
    budget_actual_overrun: 'Budget overrun (actual)',
    budget_actual_overrun_percent: 'Budget overrun (actual, %)',
    actual_spending: 'Actual spending',
    forecast_end_of_month: 'Forecast (end of month)',
    unattested_resources: 'Unattested resources',
    forecast_saving_potential: 'Forecast saving potential',
    unallocated_resources: 'Unallocated resources',
    forecast: 'Forecast',
    saving_potential: 'Saving potential',
};
/** Internal flags that must never be shown as context rows. */
const CONTEXT_HIDDEN_FIELD_NAMES = new Set([
    'show_last_month_label',
    'subtype',
]);
export function isHiddenContextField(key) {
    return CONTEXT_HIDDEN_FIELD_NAMES.has(key);
}
/**
 * Returns a people-friendly label for a context key.
 * Already-mapped display names (and unknown keys) are returned as-is.
 */
export function getContextDisplayLabel(key) {
    return CONTEXT_FIELD_DISPLAY_NAMES[key] ?? key;
}
